export default {
    isDemandLoading   : state => state.loading,
    isDemandFormSaving: state => state.saving,
    getLocalDemands   : state => state.demands
};
